export default __webpack_public_path__ + "static/media/DSCN2319.9973de8f.JPG";